var map = {
	"./de/mechaName.png": "iD54",
	"./en/mechaName.png": "a80L",
	"./es/mechaName.png": "l5lA",
	"./fr/mechaName.png": "Y3j/",
	"./ja/mechaName.png": "ryJv",
	"./ko/mechaName.png": "vPXU",
	"./pt/mechaName.png": "sWOx",
	"./ru/mechaName.png": "hYrP",
	"./tc/mechaName.png": "ACxM",
	"./th/mechaName.png": "Qibe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zPVU";